import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const API_URL = 'https://us-central1-global-pagoda-453900-f2.cloudfunctions.net/addEmail';

const MailingListForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const requestBody = { email };

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'AIzaSyAVA0c25tC__VgmuPFhraf2l4BPffx5ev4',
        },
        body: JSON.stringify(requestBody),
      });
      if (response.ok) {
        const responseText = await response.text();
        setMessage('Thank you for subscribing!' + responseText);
        setEmail('');
      } else {
        setMessage('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <>
      <div
        style={{
          padding: '20px',
          maxWidth: '500px',
          margin: '20px auto',
          border: '2px solid #cb4f2e',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#fff4e6',
          paddingBottom: '20px',
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <TextField
            id="outlined-basic"
            label="Enter your email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{
              marginBottom: '20px',
              width: '100%', // Full width for mobile
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              },
            }}
          />

          <Button
            type="submit"
            color="secondary"
            variant="contained"
            endIcon={<SendIcon />}
            sx={{
              width: '100%', // Full width for mobile
              color: '#f0e9d4',
              '&:hover': { color: '#ffffff', backgroundColor: '#cb4f2e' },
            }}
          >
            Subscribe
          </Button>
        </form>
        {message && <p style={{ textAlign: 'center', marginTop: '10px' }}>{message}</p>}

        <h2 className="text-xl font-semibold text-center text-blue-800" style={{ marginTop: '20px' }}>
          <MailOutlineIcon style={{ fontSize: '24px', marginRight: '8px', verticalAlign: 'middle' }} />
          Join Our Mailing List for Early Access & Exclusive Perks
        </h2>

        <ul className="list-disc list-inside text-gray-700" style={{ marginTop: '10px' }} aria-label="Mail Icon">
          <li>✅ Find out about any special promotions</li>
          <li>✅ Tips on tattoo removal prep and aftercare</li>
          <li>✅ Get notified about Tattoo Conventions or other events we are attending</li>
        </ul>
      </div>
    </>
  );
};

export default MailingListForm;